import React, { useState, useEffect, useRef } from "react";
import apiService from "../../utils/apiService";
import { API_BASE_URL } from "../../utils/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import { selectAvailableBalance, selectWallets } from "../../store/slices/walletSlice";
import {
  fetchUserWallet as fetchUserWalletAction,
  selectWalletLoading,
  selectWalletError,
} from "../../store/slices/walletSlice";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../utils/formatNumber";
const BalanceDashboard = () => {
  const dispatch = useDispatch();

  const [autoExchange, setAutoExchange] = useState(true);
  const [autoFees, setAutoFees] = useState(true);
  const [filterValue, setFilterValue] = useState("today");
  const walletData = useSelector(selectWallets);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [balanceError, setBalanceError] = useState(null);
    const { t } = useTranslation();

  const availableBalance = useSelector(selectAvailableBalance);
  // const [walletData, setWalletData] = useState(null);
  // console.log("bfhgfr555kwhgrkhg", walletData)
  const [walletLoading, setWalletLoading] = useState(false);
  const [walletError, setWalletError] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  // const [availableBalance, setAvailableBalance] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: ""
  });
  const [showDatePicker, setShowDatePicker] = useState(false);
  const dropdownRef = useRef(null);
  const openTronScan = () => {
    const trc20Address = getTRC20WalletAddress();
    console.log("brghteh", trc20Address);
    if (trc20Address) {
      // Get environment from localStorage
      const environment = localStorage.getItem("apiEnvironment") || "staging";
      // Use nile.tronscan.org for staging, tronscan.org for production
      const baseUrl =
        environment === "production"
          ? "https://tronscan.org"
          : "https://nile.tronscan.org";
      const url = `${baseUrl}/#/address/${trc20Address}`;
      window.open(url, "_blank");
    } else {
      // Show alert if no wallet address is available
      alert("TRC20 wallet address not available. Please try again later.");
    }
  };

  const openEtherscan = () => {
    const erc20Address = getERC20WalletAddress();
    if (erc20Address) {
      // Get environment from localStorage
      const environment = localStorage.getItem("apiEnvironment") || "staging";
      // Use sepolia.etherscan.io for staging, etherscan.io for production
      const baseUrl =
        environment === "production"
          ? "https://etherscan.io"
          : "https://sepolia.etherscan.io";
      const url = `${baseUrl}/address/${erc20Address}`;
      window.open(url, "_blank");
    } else {
      // Don't open anything if no wallet address is available
    }
  };

  const getTRC20WalletAddress = () => {
    if (
      !dashboardData ||
      !dashboardData.wallet ||
      !Array.isArray(dashboardData.wallet)
    )
      return null;

    const trc20Wallet = dashboardData.wallet.find(
      (wallet) => wallet.walletNetwork === "USDT-TRC20"
    );

    return trc20Wallet ? trc20Wallet.walletAddress : null;
  };

  const getERC20WalletAddress = () => {
    if (!dashboardData || !Array.isArray(dashboardData.wallet)) return null;

    const erc20Wallet = dashboardData.wallet.find(
      (wallet) => wallet.walletNetwork === "USDT-ERC20"
    );

    return erc20Wallet ? erc20Wallet.walletAddress : null;
  };

    const calculateAndStoreBarPercentages = (dashboardData) => {
    if (!dashboardData) {
      return { feePercentage1: 0, availablePercentage1: 0 };
    }

    const totalAmount = dashboardData.totalAmount || 0;
    const availableBalanceVal = dashboardData.availableBalance || 0;
    const feeAmount = dashboardData.feeAmt || 0;

    const sumOfAll = totalAmount + availableBalanceVal + feeAmount;

    let feePercentage = 0;
    let availablePercentage = 0;

    if (sumOfAll === 0) {
      feePercentage = 33.33;
      availablePercentage = 33.34;
    } else {
      feePercentage = (feeAmount / sumOfAll) * 100;
      availablePercentage = (availableBalanceVal / sumOfAll) * 100;
    }

    feePercentage = Math.max(0, Math.min(100, feePercentage));
    availablePercentage = Math.max(0, Math.min(100, availablePercentage));

    const total = feePercentage + availablePercentage;
    const feePercentage1 = total > 0 ? (feePercentage / total) * 100 : 0;
    const availablePercentage1 = total > 0 ? (availablePercentage / total) * 100 : 0;

    // Store bar chart percentages in localStorage
    try {
      const barChartData = {
        feePercentage1: feePercentage1,
        availablePercentage1: availablePercentage1
      };
      localStorage.setItem('barChartPercentages', JSON.stringify(barChartData));
    } catch (storageErr) {
      console.error("Error storing bar chart percentages in localStorage:", storageErr);
    }

    return { feePercentage1, availablePercentage1 };
  };

  // Fetch dashboard data from API
  const fetchDashboardData = async (filter = "last3Months", customRange = null) => {
    setLoading(true);
    setError(null);
    setBalanceLoading(true);
        setBalanceError(null);


    try {
      let url = `${API_BASE_URL}/dashboard/merchant?filter=${filter}`;

      // Add custom date range parameters if provided
      if (filter === "customRange" && customRange && customRange.from && customRange.to) {
        url += `&startDate=${customRange.from}&endDate=${customRange.to}`;
      }

      const response = await fetch(url, {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        console.log("cfsfgs", data.data);

        setDashboardData(data.data);
        calculateAndStoreBarPercentages(data.data);

      } else {
        calculateAndStoreBarPercentages(data);

        setDashboardData(data);

      }
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setBalanceLoading(false);

      // Provide more user-friendly error messages
      let errorMessage = "Failed to fetch dashboard data";
      if (err.message.includes("401")) {
        errorMessage = "Authentication required. Please log in again.";
      } else if (err.message.includes("403")) {
        errorMessage =
          "Access denied. You don't have permission to view dashboard data.";
      } else if (err.message.includes("404")) {
        errorMessage = "Dashboard endpoint not found. Please contact support.";
      } else if (err.message.includes("500")) {
        errorMessage = "Server error. Please try again later.";
      } else if (
        err.message.includes("NetworkError") ||
        err.message.includes("fetch")
      ) {
        errorMessage =
          "Network error. Please check your connection and try again.";
      }
      setBalanceLoading(false);
        setBalanceError(errorMessage);

      setError(errorMessage);
    } finally {
      setBalanceLoading(false);

      setLoading(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchUserWalletAction());
  }, [dispatch]);


  // Fetch data on component mount and when filter changes
  useEffect(() => {
    if (filterValue === "customRange") {
      // Don't fetch automatically for custom range, wait for date selection
      return;
    }
    fetchDashboardData(filterValue);
  }, [filterValue]);

  // Handle custom date range submission
  const handleCustomDateSubmit = () => {
    if (customDateRange.from && customDateRange.to) {
      fetchDashboardData("customRange", customDateRange);
      setShowDatePicker(false);
    }
  };

  // Calculate dynamic percentages for the bar chart (Three segments only)
  const calculateBarPercentages = () => {
    if (!dashboardData) {
      return { totalPercentage: 0, feePercentage: 0, availablePercentage: 0 };
    }

    const totalAmount = dashboardData.totalAmount || 0;
    const availableBalance = dashboardData.availableBalance || 0;
    const feeAmount = dashboardData.feeAmt || 0;

    // Calculate the sum of all three values
    const sumOfAll = totalAmount + availableBalance + feeAmount;

    // If sum is 0, return equal distribution or 0
    if (sumOfAll === 0) {
      return { totalPercentage: 33.33, feePercentage: 33.33, availablePercentage: 33.34 };
    }

    // Calculate percentages based on the sum of all values
    const totalPercentage = (totalAmount / sumOfAll) * 100;
    const feePercentage = (feeAmount / sumOfAll) * 100;
    const availablePercentage = (availableBalance / sumOfAll) * 100;

    return {
      totalPercentage: Math.max(0, Math.min(100, totalPercentage)),
      feePercentage: Math.max(0, Math.min(100, feePercentage)),
      availablePercentage: Math.max(0, Math.min(100, availablePercentage))
    };
  };

  const { totalPercentage, feePercentage, availablePercentage } = calculateBarPercentages();

  const total = feePercentage + availablePercentage;

  // const feePercentage1 = (feePercentage / total) * 100;
  // const availablePercentage1 = (availablePercentage / total) * 100;

  const fetchUserWallet = async () => {
    setWalletLoading(true);
    setWalletError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/dashboard/user-wallet`, {
        method: 'GET',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      // console.log("User Wallet Response:", data);

      if (data.success) {
        // setWalletData(data.data.wallets);
        //  setAvailableBalance(data?.data)
      } else {
        // setWalletData(data);
      }
    } catch (err) {
      console.error("Error fetching user wallet:", err);
      setWalletError(err.message || "Failed to fetch wallet data");
    } finally {
      setWalletLoading(false);
    }
  };

  // Fetch wallet data on component mount
  useEffect(() => {
    fetchUserWallet();
  }, [])
  // Calculate bar chart percentages with localStorage fallback
  const getBarChartPercentages = () => {
    // Try to get from localStorage first
    try {
      const cachedBarChart = localStorage.getItem('barChartPercentages');
      if (cachedBarChart) {
        const parsed = JSON.parse(cachedBarChart);
        if (parsed.feePercentage1 !== undefined && parsed.availablePercentage1 !== undefined) {
          return {
            feePercentage1: parsed.feePercentage1,
            availablePercentage1: parsed.availablePercentage1
          };
        }
      }
    } catch (err) {
      console.error("Error reading bar chart percentages from cache:", err);
    }

    // Fallback to calculation from dashboardData
    const { totalPercentage, feePercentage, availablePercentage } = calculateBarPercentages();
    const total = feePercentage + availablePercentage;
    const feePercentage1 = total > 0 ? (feePercentage / total) * 100 : 0;
    const availablePercentage1 = total > 0 ? (availablePercentage / total) * 100 : 0;

    return { feePercentage1, availablePercentage1 };
  };

  const { feePercentage1, availablePercentage1 } = getBarChartPercentages();

  const erc20Fee = walletData?.find(w => w.walletNetwork === "USDT-ERC20")?.feeAmount || 0;
  const trc20Fee = walletData?.find(w => w.walletNetwork === "USDT-TRC20")?.feeAmount || 0;
  const totalFee = erc20Fee + trc20Fee;

  return (
    <div className="relative flex flex-col xl:flex-row gap-4 bg-gray-100 w-full">
      {/* Balance Summary Card */}
       <div className="bg-white rounded-[25px] p-4 lg:p-6 shadow-sm flex-1 xl:flex-[2]">
            {/* Header Section - Mobile Optimized */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-3">
              <h2 className="text-lg font-semibold text-gray-900">
               {t("recentDashboard.balanceSummary")}
              </h2>

          {/* <div className="flex flex-col sm:flex-row gap-2">
            <button
              onClick={openTronScan}
              className="flex items-center justify-center space-x-2 px-3 py-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors text-sm"
            >
              <svg
                className="w-4 h-4 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                />
              </svg>
              <span className="font-medium">TRC20</span>
            </button>
            <button
              onClick={openEtherscan}
              className="flex items-center justify-center space-x-2 px-3 py-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors text-sm"
            >
              <svg
                className="w-4 h-4 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                />
              </svg>
              <span className="font-medium">ERC20</span>
            </button>
          </div> */}
              {/* Action Buttons - Mobile Responsive */}
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
                {/* Filter Dropdown */}
            {/* <div className="relative" ref={dropdownRef}>
                  {isFilterOpen && (
                    <div className="absolute right-0 sm:right-0 left-0 sm:left-auto mt-2 w-full sm:w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                      <div className="py-1">
                        {filterOptions?.map((option) => (
                          <button
                            key={option.value}
                            onClick={() => {
                              setFilterValue(option.value);
                              setIsFilterOpen(false);
                              if (option.value === "customRange") {
                                setShowDatePicker(true);
                              }
                            }}
                        className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 transition-colors ${
                          filterValue === option.value
                              ? "bg-blue-50 text-blue-700"
                              : "text-gray-700"
                              }`}
                          >
                            {option.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
            </div> */}
              </div>
            </div>

            <div className="w-full bg-gray-200 rounded-md h-9 mb-4 overflow-hidden">
              <div className="h-full flex">
                {feePercentage1 > 0 && (
                  <div
                    className="bg-[#4FC3F7] flex-shrink-0 transition-all duration-300"
                    style={{ width: `${feePercentage1}%` }}
                    title={`Fees: ${formatNumber(feePercentage1, 2)}%`}
                  ></div>
                )}
                {availablePercentage1 > 0 && (
                  <div
                    className="bg-blue-500 flex-shrink-0 transition-all duration-300"
                    style={{ width: `${availablePercentage1}%` }}
                    title={`Available Balance: ${formatNumber(availablePercentage1, 2)}%`}
                  ></div>
                )}
              </div>
            </div>

            {balanceError && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                <div className="flex items-center">
                  <svg
                    className="w-5 h-5 text-red-400 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="text-red-700 text-sm">{balanceError}</span>
                </div>
                <button
                  onClick={() => fetchDashboardData(filterValue)}
                  className="mt-2 text-red-600 hover:text-red-800 text-sm underline"
                >
                  Try again
                </button>
              </div>
            )}

            {/* Data Table - Mobile Responsive with Row Layout */}
            <div className="space-y-0">
              {/* Header - Hidden on mobile, shown on larger screens */}
              <div className="hidden sm:flex justify-between items-center py-3 border-b border-gray-200">
                <span className="font-semibold text-gray-900 text-sm lg:text-base">
                   {t("recentDashboard.balnaceType")}
                </span>
                <span className="font-semibold text-gray-900 text-sm lg:text-base">
                   {t("recentDashboard.Amount")}
                </span>
              </div>

              {/* Fee Amount Row */}
              {/* <div className="flex justify-between items-center py-4 sm:py-3 lg:py-4 border-b border-gray-200">
                <div className="flex items-center space-x-2 lg:space-x-3">
                  <div className="w-4 h-4 bg-[#4FC3F7] rounded-sm flex-shrink-0"></div>
                  <span className="text-gray-900 text-sm lg:text-base font-medium sm:font-normal">
                    {t("recentDashboard.FeeAmount")}
                  </span>
                </div>
                <span className="text-gray-900 font-semibold text-sm sm:text-base lg:text-base">
                  {formatNumber(totalFee, 2)} USDT
                </span>
              </div> */}

              {/* Available Balance Row */}
              <div className="flex justify-between items-center py-4 sm:py-3 lg:py-4 border-b border-gray-200">
                <div className="flex items-center space-x-2 lg:space-x-3">
                  <div className="w-4 h-4 bg-blue-500 rounded-sm flex-shrink-0"></div>
                  <span className="text-gray-900 text-sm lg:text-base font-medium sm:font-normal">
                    {t("recentDashboard.AvailableBalance")}
                  </span>
                </div>
                <span className="text-gray-900 font-semibold text-sm sm:text-base lg:text-base">
                  {formatNumber(availableBalance?.availableBalance || 0, 2)} USDT
                </span>
              </div>
            </div>

        <div className="flex justify-between items-center py-4 sm:py-3 lg:py-4 border-b border-gray-200">
          <div className="flex items-center space-x-2 lg:space-x-3">
            <div className="w-4 h-4 bg-green-500 rounded-sm flex-shrink-0"></div>
            <span className="text-gray-900 text-sm lg:text-base font-medium sm:font-normal">
              ERC20 Amount
            </span>
          </div>
          <span className="text-gray-900 font-semibold text-sm sm:text-base lg:text-base">
            
            {walletData
              ?.find((w) => w.walletNetwork === "USDT-ERC20")
              ?.balance?.toFixed(2) || "0.00"}{" "}
            USDT
          </span>
        </div>

        {/* TRC20 Amount Row - Always Row Layout on Small Devices */}
        <div className="flex justify-between items-center py-4 sm:py-3 lg:py-4 border-b border-gray-200">
          <div className="flex items-center space-x-2 lg:space-x-3">
            <div className="w-4 h-4 bg-gray-600 rounded-sm flex-shrink-0"></div>
            <span className="text-gray-900 text-sm lg:text-base font-medium sm:font-normal">
              TRC20 Amount
            </span>
          </div>
          <span className="text-gray-900 font-semibold text-sm sm:text-base lg:text-base">
            $
            {walletData
              ?.find((w) => w.walletNetwork === "USDT-TRC20")
              ?.balance?.toFixed(2) || "0.00"}{" "}
            USDT
          </span>
        </div>

            {/* Fallback when no data */}
            {!balanceLoading && !balanceError && !dashboardData && (
              <div className="text-center py-8 text-gray-500">
                <p> {t("recentDashboard.noDataFound")}</p>
              </div>
            )}
          </div>
    </div>
  );
};

export default BalanceDashboard;
